<template>
  <div>
    <Toolbar :handle-edit="() => editHandler(item)" :hasAccess="userHasAccess('qualitychecktest_edit')" >
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>{{ item['name'] }}</h1>
        </v-toolbar-title>
      </template>
    </Toolbar>

    <br />

    <div v-if="item" class="table-qualitychecktest-show">
      <v-img
        class = "ma-2"
        max-height="250"
        max-width="250"
        lazy-src="@/assets/imagenotfound.png"
        :key="componentKey"
        :src="imageurlItem"
      >
        <ImageForm
          ref="updateForm"
          :item="item"
          v-if="userHasAccess('qualitychecktest_edit')"
        />
          <v-btn
            color="secondary"
            small
            absolute
            bottom
            right
            @click="downloadItem()"
          >
            <v-icon>mdi-download-circle</v-icon>
          </v-btn>
      </v-img>
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>{{ $t('qualitycheck.test.number') }}</strong></td>
              <td>
                {{ $n(item['number']) }}              </td>

                <td><strong>{{ $t('qualitycheck.test.refexternal') }}</strong></td>
                <td>
                  {{ item['refExternal'] }}              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.test.name') }}</strong></td>
              <td>
                                    {{ item['name'] }}
              </td>

              <td><strong>{{ $t('qualitycheck.test.namefr') }}</strong></td>
              <td>
                                    {{ item['namefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.test.issue') }}</strong></td>
              <td>
                                    {{ item['issue'] }}
              </td>

              <td><strong>{{ $t('qualitycheck.test.issuefr') }}</strong></td>
              <td>
                                    {{ item['issuefr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.test.comment') }}</strong></td>
              <td>
                                    {{ item['comment'] }}
              </td>

              <td><strong>{{ $t('qualitycheck.test.commentfr') }}</strong></td>
              <td>
                                    {{ item['commentfr'] }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.test.type') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['type']" :key="_item">
                    {{ _item }}
                  </li>
                </ul>

              </td>

              <td><strong>{{ $t('qualitycheck.test.typevalue') }}</strong></td>
              <td>
                <ul>
                  <li v-for="_item in item['valueType']" :key="_item.id">
                    {{ _item.name }}
                  </li>
                </ul>
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';
import FileMixin from '../../mixins/FileMixin';
import ImageForm from '../../components/ImageForm.vue';

const servicePrefix = 'QualityCheckTest';

export default {
  name: 'QualityCheckTestShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar,
      ImageForm
  },
  data: () => ({
    filter: '',
  }),
  mixins: [ShowMixin,AccessMixin,FileMixin],
  computed: {
    ...mapFields('qualitychecktest', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('qualitychecktest', ['find'])
  },
  methods: {
    ...mapActions('qualitychecktest', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
